import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
	name: 'safe',
	standalone: false
})
export class SafePipe {
	constructor(protected _sanitizer: DomSanitizer) {
	}

	public transform(value: string, type: string = 'html'): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
		switch (type) {
			case 'html': return this._sanitizer.bypassSecurityTrustHtml(value);
			case 'style': return this._sanitizer.bypassSecurityTrustStyle(value);
			case 'script': return this._sanitizer.bypassSecurityTrustScript(value);
			case 'url': return this._sanitizer.bypassSecurityTrustUrl(value);
			case 'resourceUrl': return this._sanitizer.bypassSecurityTrustResourceUrl(value);
			default: throw new Error(`Invalid safe type specified: ${type}`);
		}
	}
}

/* ex 2/14/24, 09:49 AM */
@Pipe({
	name: 'formatDateTime',
	pure: true,
	standalone: false
})
export class FormatDateTimePipe implements PipeTransform {
	transform(value: string): any {
		return this.getDateTime(value);
	}
	getDateTime(date: string): string {
		try {
			var t = new Date(date);
			return t.toLocaleTimeString([], { year: '2-digit', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' });
		}
		catch (ex) {
			return "";
		}
	}
}

/* ex December 19, 2012 */
@Pipe({
	name: 'formatDate',
	pure: true,
	standalone: false
})
export class FormatDatePipe implements PipeTransform {
	transform(value: string): any {
		return this.getDateTime(value);
	}
	getDateTime(date: string): string {
		try {
			var t = new Date(date);
			return t.toLocaleDateString([], { year: '2-digit', month: 'short', day: 'numeric' });
		}
		catch (ex) {
			return "";
		}
	}
}
